import React, {useEffect, useRef} from 'react'
import PropTypes from 'prop-types'
import {Text, Stack, Accordion} from '@salesforce/retail-react-app/app/components/shared/ui'

import PDComponent from '../../pd-component'
import Schema from './partials/schema'
import usePdTagManager from '../../../../hooks/use-pd-tag-manager'

export const FAQ = ({
    title,
    titleColor,
    subtitle,
    subtitleColor,
    regions,
    product,
    titleFontFamily,
    name,
    typeId
}) => {
    const accordionRef = useRef(null)
    const pdTagManager = usePdTagManager()
    const chidlCount = regions?.[0]?.components?.length || 0
    const analyticsProps = {
        componentType: typeId,
        componentName: title
    }

    useEffect(() => {
        if (location?.hash) {
            const sectionToScroll = location.hash
            setTimeout(() => {
                if (sectionToScroll) {
                    let position
                    const domElement = document.querySelector(sectionToScroll)

                    if (domElement) {
                        position = domElement?.offsetTop
                        window.scrollTo({
                            top: position,
                            behavior: 'smooth'
                        })
                    }
                }
            }, 250)
        }
    }, [accordionRef?.current])

    useEffect(() => {
        if (!chidlCount) return
        pdTagManager.viewComponent(typeId, name || title, chidlCount)
    }, [])

    return (
        <Stack
            marginTop="50px"
            marginBottom="40px"
            gap="20px"
            className="faq-section-stack"
            width="100%"
            maxWidth="1140px"
            marginX="auto"
            paddingX="20px"
        >
            <Schema regions={regions} />

            {title || subtitle ? (
                <Stack gap="10px" color="black.100" id="faq-section">
                    {title && (
                        <Text
                            as="h3"
                            className="faq-text"
                            color={titleColor}
                            fontSize={{base: '29px', md: '32px'}}
                            fontWeight="400"
                            fontFamily={titleFontFamily}
                            lineHeight="normal"
                            letterSpacing="0.135px"
                        >
                            {title}
                        </Text>
                    )}

                    {subtitle && (
                        <Text
                            fontWeight="300"
                            fontSize="16px"
                            color={subtitleColor}
                            className="faq-subtitle-text"
                            lineHeight="25px"
                            letterSpacing="0.08px"
                        >
                            {subtitle}
                        </Text>
                    )}
                </Stack>
            ) : null}

            <Accordion
                defaultIndex={[0]}
                variant="accordion"
                ref={accordionRef}
                allowToggle={true}
                className="faq-accordion-wrapper"
            >
                {regions?.map((region) =>
                    region?.components?.map((component, index) => (
                        <PDComponent
                            key={`${region.id}-${index}`}
                            component={component}
                            product={product}
                            analyticsProps={{
                                ...analyticsProps,
                                index: index
                            }}
                        />
                    ))
                )}
            </Accordion>
        </Stack>
    )
}

FAQ.propTypes = {
    title: PropTypes.string,
    titleColor: PropTypes.string,
    subtitle: PropTypes.string,
    subtitleColor: PropTypes.string,
    titleFontFamily: PropTypes.string,
    product: PropTypes.any,
    typeId: PropTypes.string,
    name: PropTypes.any,
    regions: PropTypes.arrayOf(
        PropTypes.shape({
            components: PropTypes.arrayOf(
                PropTypes.shape({
                    data: PropTypes.shape({
                        question: PropTypes.string,
                        answer: PropTypes.string
                    })
                })
            )
        })
    ).isRequired
}

export default FAQ
